import React from 'react';
import { useFormikContext, ErrorMessage } from 'formik';
import Item from '../../../components/Form/Item';
import { Select } from 'antd';

const types = [
  {
    id: 1,
    name: 'Internal'
  },
  {
    id: 2,
    name: 'Eksternal'
  }
];
const Type = () => {
  const formik = useFormikContext();
  return (
    <>
      <Item name="Jenis Training">
        <Select
          defaultValue={formik.values.type}
          onChange={(value) => {
            formik.setFieldValue("type", value);
          }}
          placeholder="Pilih Jenis Training"
        >
          {types.map((types, key) => {
            return <Select.Option value={types.id} key={`types-${key}`}>
              {types.name}
            </Select.Option>
          })}
        </Select>
        <ErrorMessage component="div" className="gx-text-danger" name="type" />
      </Item>
    </>
  );
}

export default Type;